import styled from 'styled-components';

const HeaderWrapper = styled.div`
    height: 3.75rem;
    border-bottom: 0.125rem solid ${props => props.theme.color};
    text-align: center;
    vertical-align: center;
    position: relative;
`;

export default HeaderWrapper;
